var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.combo,"value":_vm.value,"label":"Responsável"},on:{"input":_vm.alteraValor}})}
var staticRenderFns = []

export { render, staticRenderFns }